module.exports = __webpack_public_path__ + "static/img/top-image.0447428.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/menu/images/top-image.png
// module id = qTfR
// module chunks = 1